import { Box, Chip, Divider, Grid2, Stack, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import CommonTextField from "../../../../component/Input";
import DropDownSelect from "../../../../component/Select";
import {
  CommonGrid2,
  StyledFlexColumnView,
} from "../../../common-components/StyledComponents";
import FileUpload from "../../../matches/quick-match/components/FileUpload";
import CommonInputJd from "./CommonInputJd";
import { CommonTippy, CustomizeSpan } from "../../style";
import { StyledLinearContainer } from "../../../matches/quick-match/components/StyledComponent";
import CommonLinearProgress from "../../../../component/Linearprogress";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import JobOwnerExecutive from "./JobOwnerExecutive";

function InputJobData({
  inputJdView,
  handleButtonCommon,
  handleFileUpload,
  enrichFile,
  buttonLoading,
  handleInputJobDeleteFile,
  handleInputJobDragOver,
  handleInputJobDragLeave,
  handleInputJobDrop,
  inputJobDrag,
  list,
  titleInitialValues,
  JDInitialValues,
  validationSchemaTitle,
  handleTitleSubmit,
  validationSchemaJD,
  handleJDSubmit,
  userData,
  handleMenuItem,
  handleDataTime,
}) {
  return (
    <>
      {inputJdView === 1 ? (
        <CommonInputJd
          title={"Enrich existing Job Post"}
          buttonName={"Import Job Post"}
          loading={buttonLoading}
          disabled={enrichFile?.length === 0}
          handleButtonCommon={() => handleButtonCommon(inputJdView)}
          marginTop="-1.5rem"
        >
           <Box sx={{ mb: 3 }}>
            <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1 }}>
              <Typography fontSize="13px" fontWeight={600} color="#101828">
                Job Description File
              </Typography>
              <Typography fontSize="13px" fontWeight={400} color="#667085">
                (Please upload a clear and readable Job file only)
              </Typography>
              <Typography fontSize="13px" fontWeight={600} color="#F04438">
                *
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              flexWrap="wrap"
              gap={0.75}
              sx={{
                px: 1.5,
                py: 1,
                bgcolor: "#F9FAFB",
                border: "1px solid #EAECF0",
                borderRadius: "8px",
                width: "fit-content",
              }}
            >
              <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                Supported formats:
              </Typography>
              {["PDF", "DOC", "DOCX"].map((fmt) => (
                <Chip
                  key={fmt}
                  label={fmt}
                  size="small"
                  sx={{
                    height: "22px",
                    fontSize: "11px",
                    fontWeight: 600,
                    color: "#6941C6",
                    bgcolor: "#F4EBFF",
                    border: "1px solid #E9D7FE",
                    borderRadius: "6px",
                    "& .MuiChip-label": { px: "8px" },
                  }}
                />
              ))}
              <Divider orientation="vertical" flexItem sx={{ mx: 0.5, borderColor: "#EAECF0" }} />
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography fontSize="11.5px" fontWeight={500} color="#667085">
                  Max size:
                </Typography>
                <Typography
                  fontSize="11.5px"
                  fontWeight={700}
                  color="#344054"
                  sx={{
                    px: 0.75,
                    py: 0.1,
                    bgcolor: "#F2F4F7",
                    borderRadius: "4px",
                    border: "1px solid #D0D5DD",
                  }}
                >
                  5 MB
                </Typography>
              </Stack>
            </Stack>
          </Box>
          <FileUpload
            onDragOver={handleInputJobDragOver}
            onDragLeave={handleInputJobDragLeave}
            onDrop={handleInputJobDrop}
            onChange={handleFileUpload}
            isDragging={inputJobDrag}
            files={enrichFile}
            handleDeleteFile={handleInputJobDeleteFile}
            disabled={buttonLoading}
          />
          <JobOwnerExecutive
            userData={userData}
            handleMenuItem={handleMenuItem}
            handleDataTime={handleDataTime}
            loading={userData.loading}
          />
        </CommonInputJd>
      ) : null}

      {inputJdView === 2 ? (
        <Formik
          initialValues={JDInitialValues}
          onSubmit={handleJDSubmit}
          validationSchema={validationSchemaJD}
        >
          {({ values, handleChange, setFieldValue, errors, touched }) => {
            return (
              <Form>
                <CommonInputJd
                  title={"Create a Job Post using Simple Job Description"}
                  buttonName={"Generate Job Post"}
                  disabled={list.disabled || list.loading}
                  loading={list.buttonLoading}
                >
                  <Grid2 container spacing={2}>
                    <Grid2 size={12}>
                      <CommonGrid2
                        display={"flex"}
                        gap={list.loading ? "0px" : "10px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "#344054",
                          }}
                        >
                          {"Job Description"}
                          <CustomizeSpan color={"red"}> *</CustomizeSpan>
                        </Typography>

                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <CommonTextField
                            value={values["sample_jd_text"]}
                            error={Boolean(
                              touched["sample_jd_text"] &&
                                errors["sample_jd_text"]
                            )}
                            helperText={
                              touched["sample_jd_text"] &&
                              errors["sample_jd_text"]
                            }
                            placeholder="Enter Job Description"
                            padding="0px"
                            placeholderFontSize={"15px"}
                            multiline
                            rows={4}
                            fontSize={"15px"}
                            onChange={(event) => {
                              setFieldValue(
                                "sample_jd_text",
                                event.target.value
                              );
                            }}
                          />
                        )}
                      </CommonGrid2>
                    </Grid2>

                    <Grid2 size={12}>
                      <CommonGrid2
                        display={"flex"}
                        gap={list.loading ? "0px" : "10px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          fontWeight={500}
                          fontSize={"16px"}
                          color={"#344054"}
                        >
                          {"Industry"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <DropDownSelect
                            value={values["industry"]}
                            marginTop="0px"
                            title={"Select Industry"}
                            removeAnimation={true}
                            data={list?.industry}
                            handleChange={(event) => {
                              setFieldValue("industry", event.target.value);
                            }}
                          />
                        )}
                      </CommonGrid2>
                    </Grid2>
                    <Grid2 size={12}>
                      <CommonGrid2
                        display={"flex"}
                        gap={list.loading ? "0px" : "10px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          fontWeight={500}
                          fontSize={"16px"}
                          color={"#344054"}
                        >
                          {"Location"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <CommonTextField
                            value={values["location"]}
                            placeholder="Enter a Location"
                            padding="11px"
                            placeholderFontSize={"15px"}
                            onChange={(event) => {
                              setFieldValue("location", event.target.value);
                            }}
                          />
                        )}
                      </CommonGrid2>
                    </Grid2>

                    <Grid2 size={12}>
                      <CommonGrid2
                        display={"flex"}
                        gap={list.loading ? "0px" : "10px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "#344054",
                          }}
                        >
                          {"Occupational Classification"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <DropDownSelect
                            value={values["occupational_classification"]}
                            marginTop="0px"
                            title={"Occupational Classification"}
                            removeAnimation={true}
                            data={list?.classification}
                            handleChange={(event) => {
                              setFieldValue(
                                "occupational_classification",
                                event.target.value
                              );
                            }}
                          />
                        )}
                      </CommonGrid2>
                    </Grid2>
                    <Grid2 size={12}>
                      <JobOwnerExecutive
                        userData={userData}
                        handleMenuItem={handleMenuItem}
                        marginBottom="0px"
                        loading={list.loading}
                        handleDataTime={handleDataTime}
                      />
                    </Grid2>

                    {list.progress >= 0 && (
                      <Grid2
                        size={12}
                        marginBottom={"-1rem"}
                        marginTop={"0.5rem"}
                      >
                        <CommonTippy
                          content={list.message}
                          visible={list.visible}
                          interactive={true}
                          trigger="click"
                          hideOnClick={false}
                          zIndex={2}
                          color="red"
                        >
                          <CustomDiv>
                            <StyledLinearContainer>
                              <CommonLinearProgress
                                variant={
                                  list.progress && !list.visible
                                    ? "buffer"
                                    : "determinate"
                                }
                                value={list.progress}
                                valueBuffer={list.buffer}
                                height={"8px"}
                                borderRadius={"2px"}
                                backgroundColor={"#E0E0E0"}
                                barbackgroundColor={
                                  list.visible ? "red" : "#7F56D9"
                                }
                                dashedmarginTop={"2px"}
                                dashedbackgroundImage={
                                  list.visible
                                    ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                                    : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                                }
                              />

                              <Typography
                                color="#344054"
                                fontSize={"14px"}
                                fontWeight={500}
                              >
                                {list.progress}%
                              </Typography>
                            </StyledLinearContainer>
                            {list.progress_message && (
                              <CustomizeSpan
                                fontSize="12px"
                                color="#475467"
                                sx={{
                                  letterSpacing: "0.2px",
                                  animation: "wave 1.5s ease-in-out infinite",
                                  "@keyframes wave": {
                                    "0%, 100%": { transform: "translateY(0)" },
                                    "50%": { transform: "translateY(-4px)" },
                                  },
                                }}
                              >
                                {list.progress_message} . . .
                              </CustomizeSpan>
                            )}
                          </CustomDiv>
                        </CommonTippy>
                      </Grid2>
                    )}
                  </Grid2>
                </CommonInputJd>
              </Form>
            );
          }}
        </Formik>
      ) : null}

      {inputJdView === 3 ? (
        <Formik
          initialValues={titleInitialValues}
          onSubmit={handleTitleSubmit}
          validationSchema={validationSchemaTitle}
        >
          {({ values, handleChange, setFieldValue, errors, touched }) => {
            return (
              <Form>
                <CommonInputJd
                  title={"Generate Job Post"}
                  buttonName={"Generate Job Post"}
                  disabled={list.disabled || list.loading}
                  loading={list.buttonLoading}
                >
                  <Grid2 container spacing={2}>
                    <Grid2 size={12}>
                      <StyledFlexColumnView gap={list.loading ? "0px" : "10px"}>
                        <Typography
                          fontWeight={500}
                          fontSize={"16px"}
                          color={"#344054"}
                        >
                          {"Job Title"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <CommonTextField
                            placeholder="Enter Job Title"
                            padding="11px"
                            placeholderFontSize={"15px"}
                            error={Boolean(touched["title"] && errors["title"])}
                            helperText={touched["title"] && errors["title"]}
                            value={values["title"]}
                            onChange={(event) => {
                              setFieldValue("title", event.target.value);
                            }}
                          />
                        )}
                      </StyledFlexColumnView>
                    </Grid2>

                    <Grid2 size={12}>
                      <StyledFlexColumnView gap={list.loading ? "0px" : "10px"}>
                        <Typography
                          fontWeight={500}
                          fontSize={"16px"}
                          color={"#344054"}
                        >
                          {"Industry"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <DropDownSelect
                            marginTop="0px"
                            title={"Select Industry"}
                            removeAnimation={true}
                            data={list?.industry}
                            error={Boolean(
                              touched["industry"] && errors["industry"]
                            )}
                            helperText={
                              touched["industry"] && errors["industry"]
                            }
                            value={values["industry"]}
                            handleChange={(event) => {
                              setFieldValue("industry", event.target.value);
                            }}
                          />
                        )}
                      </StyledFlexColumnView>
                    </Grid2>

                    <Grid2 size={12}>
                      <StyledFlexColumnView gap={list.loading ? "0px" : "10px"}>
                        <Typography
                          fontWeight={500}
                          fontSize={"16px"}
                          color={"#344054"}
                        >
                          {"Company"}
                        </Typography>
                        {list.loading ? (
                          <HandleSkeletion height={50} />
                        ) : (
                          <CommonTextField
                            placeholder="Enter Company"
                            padding="11px"
                            placeholderFontSize={"15px"}
                            error={Boolean(
                              touched["company"] && errors["company"]
                            )}
                            helperText={touched["company"] && errors["company"]}
                            value={values["company"]}
                            onChange={(event) => {
                              setFieldValue("company", event.target.value);
                            }}
                          />
                        )}
                      </StyledFlexColumnView>
                    </Grid2>
                  </Grid2>
                </CommonInputJd>
              </Form>
            );
          }}
        </Formik>
      ) : null}

      {inputJdView === 4 || inputJdView === 5 ? (
        <CommonInputJd
          title={"Create Job Post using Resume"}
          buttonName={"Convert Resume into Job Post"}
        >
          <StyledFlexColumnView>
            <Typography fontWeight={500} fontSize={"16px"} color={"#344054"}>
              {"Resume"}
            </Typography>
            <CommonTextField
              readOnly={true}
              handleFileChange={""}
              value={""}
              padding="12px"
              placeholder={"Choose a file"}
            />
          </StyledFlexColumnView>
        </CommonInputJd>
      ) : null}
    </>
  );
}

export default InputJobData;
